import "./style.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const MOBILE_BREAKPOINT = 767;

const initIngredients = () => {
    const blocks = document.querySelectorAll(".wp-block-ow-ingredients");

    blocks.forEach((block) => {
        const crevka = block.querySelector(".ingredients__crevka");
        const textBlock = block.querySelector(".ingredients__inner-text");
        const ingredients = block.querySelectorAll(".ingredients__inner-ingredient");
        const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

        if (!ingredients.length) {
            return;
        }

        // SVG parallax — scrolls faster than the section
        if (crevka) {
            gsap.to(crevka, {
                yPercent: isMobile ? -100 : -10,
                ease: "none",
                scrollTrigger: {
                    trigger: block,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                },
            });
        }

        if (isMobile) {
            const ingredientsScroller = block.querySelector(".ingredients__inner-ingredients");
            if (ingredientsScroller && crevka) {
                ingredientsScroller.addEventListener("scroll", () => {
                    const maxScroll = ingredientsScroller.scrollWidth - ingredientsScroller.clientWidth;
                    const progress = maxScroll > 0 ? ingredientsScroller.scrollLeft / maxScroll : 0;
                    crevka.style.setProperty("--crevka-offset", `${-progress * 120}px`);
                }, { passive: true });
            }
        }

        if (!isMobile) {
            const speeds = [-150, -280, -200, -350, -205];
            ingredients.forEach((ingredient, i) => {
                gsap.to(ingredient, {
                    yPercent: speeds[i % speeds.length],
                    ease: "none",
                    scrollTrigger: {
                        trigger: ingredients,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                    },
                });
            });
        }

        // Set initial states
        gsap.set(textBlock, {opacity: 0, y: 60});

        if (!isMobile) {
            gsap.set(ingredients, { opacity: 0, scale: 0.6 });
        }

        // Text fade/slide — plays once
        gsap.to(textBlock, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
                trigger: block,
                start: "top 60%",
                toggleActions: "play none none none", // plays once
            },
        });

        if (!isMobile) {
            ingredients.forEach((ingredient, i) => {
                gsap.to(ingredient, {
                    opacity: 1,
                    scale: 1,
                    ease: "back.out(1.4)",
                    scrollTrigger: {
                        trigger: ingredient,
                        start: `top ${100 + 10 * i}%`,
                        end: `top ${80 + 10 * i}%`,
                        scrub: true,
                        once: true,
                    },
                });
            });
        }
    });

    // Final refresh to ensure all positions are calculated after JS execution
    ScrollTrigger.refresh();
};

// Use "load" instead of "DOMContentLoaded" to wait for images/assets
window.addEventListener("load", () => {
    initIngredients();
});

// Optional: Handle window resizing to recalculate positions
window.addEventListener("resize", () => {
    ScrollTrigger.refresh();
});